import React, { lazy } from 'react';
import { ShieldAlert } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-noir-bg relative border-b border-noir-border flex justify-center" data-id="element-133">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-xl relative z-10" data-id="element-134">
        {/* Offer Card */}
        <div className="bg-noir-card border border-noir-border rounded-sm p-8 md:p-12 text-center shadow-[0_0_40px_rgba(211,47,47,0.2)] relative overflow-hidden" data-id="element-135">
          {/* Top Accent Line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-noir-alert" data-id="element-136"></div>

          <div className="inline-flex items-center justify-center w-16 h-16 bg-noir-bg border border-noir-border mb-8 rounded-sm" data-id="element-137">
            <ShieldAlert className="w-8 h-8 text-noir-alert" data-id="element-138" />
          </div>

          <h2 className="text-3xl md:text-4xl font-mono font-bold text-noir-text mb-4 uppercase" data-id="element-139">
            Acceso Autorizado
          </h2>

          <p className="text-base text-noir-muted mb-8 max-w-sm mx-auto" data-id="element-140">
            Recupera la complicidad de tu relación. Obtén el sistema completo de
            "Expediente Pareja" hoy.
          </p>

          {/* Mockup Image */}
          <div className="relative overflow-hidden border border-noir-border bg-noir-bg mb-10 mx-auto max-w-sm shadow-[0_0_20px_rgba(211,47,47,0.1)] rounded-sm group" data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/idFHUeVM8Q9vh4XP46qFkP/iPad_Pro_displaying_202603260219.jpg" alt="Expediente Pareja en iPad" loading="lazy" decoding="async" className="w-full h-auto object-cover" data-id="element-142" />
            {/* Forensic UI Overlays */}
            <div className="absolute top-2 left-2 w-3 h-3 border-t border-l border-noir-alert z-20" data-id="element-143"></div>
            <div className="absolute top-2 right-2 w-3 h-3 border-t border-r border-noir-alert z-20" data-id="element-144"></div>
            <div className="absolute bottom-2 left-2 w-3 h-3 border-b border-l border-noir-alert z-20" data-id="element-145"></div>
            <div className="absolute bottom-2 right-2 w-3 h-3 border-b border-r border-noir-alert z-20" data-id="element-146"></div>
          </div>

          <div className="mb-10 relative" data-id="element-147">
            <div className="absolute -top-4 -right-4 bg-noir-alert text-white text-xs font-bold px-3 py-1 rounded-sm transform rotate-12 shadow-lg z-10 font-mono tracking-wider" data-id="element-148">
              68% DTO
            </div>

            {/* New Instant Access Stamp */}
            <div className="inline-block border-2 border-noir-alert text-noir-alert font-mono font-bold text-xs px-2 py-1 mb-4 uppercase tracking-widest bg-noir-alert/10" data-id="element-149">
              ACCESO INSTANTÁNEO POR $6.36 USD
            </div>

            <div className="flex items-center justify-center space-x-3 mb-1" data-id="element-150">
              <span className="text-xl text-noir-muted line-through font-mono opacity-70" data-id="element-151">
                $19.87
              </span>
            </div>

            <div className="flex items-center justify-center font-mono" data-id="element-152">
              <span className="text-6xl font-bold text-noir-text" data-id="element-153">$6.36</span>
              <span className="text-xl text-noir-muted ml-2 mt-4" data-id="element-154">USD</span>
            </div>

            {/* Microcopy below price */}
            <p className="text-sm text-noir-muted mt-4 font-sans italic" data-id="element-155">
              Más económico que una sesión de terapia, más efectivo que otra
              cena mirando el celular.
            </p>
          </div>

          <div className="space-y-4" data-id="element-156">
            <a id="final-cta" href="https://pay.hotmart.com/U105129541T?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart', {
                content_name: 'Expediente Pareja',
                content_type: 'product',
                value: 6.36,
                currency: 'USD'
              });
            }
          }} className="w-full flex items-center justify-center px-6 py-5 text-lg font-bold text-white transition-all duration-200 bg-noir-alert border border-transparent rounded-sm hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-noir-alert focus:ring-offset-noir-card uppercase tracking-widest shadow-[0_0_20px_rgba(211,47,47,0.4)]" data-id="element-157">
              REABRIR EL CASO DE MI RELACIÓN
            </a>

            <div className="flex flex-col items-center justify-center text-xs text-noir-muted font-mono uppercase tracking-wider space-y-2" data-id="element-158">
              <div className="flex items-center" data-id="element-159">
                <span className="w-2 h-2 bg-green-600 rounded-sm mr-2" data-id="element-160"></span>
                Acceso instantáneo por email
              </div>
              <span className="opacity-70" data-id="element-161">
                Formato digital compatible con móviles
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}